var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 2.16927C1.33203 1.70903 1.70513 1.33594 2.16536 1.33594H3.95943C4.36679 1.33594 4.71445 1.63045 4.78142 2.03227L5.39751 5.72883C5.45766 6.08969 5.27541 6.44758 4.9482 6.61119L3.65808 7.25625C4.58833 9.56787 6.43343 11.413 8.74506 12.3432L9.39011 11.0531C9.55372 10.7259 9.91161 10.5436 10.2725 10.6038L13.969 11.2199C14.3709 11.2869 14.6654 11.6345 14.6654 12.0419V13.8359C14.6654 14.2962 14.2923 14.6693 13.832 14.6693H12.1654C6.18228 14.6693 1.33203 9.81902 1.33203 3.83594V2.16927Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPhone);
export default __webpack_public_path__ + "static/media/small-phone.0dc8baf2cd6cfdbfce86a3ba18ea5362.svg";
export { ForwardRef as ReactComponent };